import React from 'react';
import { Button, Tooltip } from 'antd';

import { keyGlyph } from '../../contexts/ShortcutsContext';

/**
 * The editors' Undo and Redo (KPR-348): two small text buttons (the form
 * layout editor's, docs/platform-standards.md), each with its shortcut in the
 * tooltip, disabled while there is nothing to step to. They are the sure way
 * for a touch screen, where there is no Cmd+Z, and for anyone who has not met
 * the shortcut.
 *
 * `disabled` is the editor holding a gesture (a drag in flight) or a surface
 * the person may not change; a button is never active when its step is not.
 */
export default function UndoRedoButtons({ canUndo, canRedo, onUndo, onRedo, disabled = false, className = '' }) {
	const mod = keyGlyph('mod');
	const shift = keyGlyph('shift');
	return (
		<div className={`undo-redo ${className}`.trim()} role="group" aria-label="Undo and redo">
			<Tooltip title={`Undo (${mod}+Z)`}>
				<Button className="undo-redo__button" size="small" type="text" disabled={disabled || !canUndo} onClick={onUndo}>Undo</Button>
			</Tooltip>
			<Tooltip title={`Redo (${mod}+${shift}+Z)`}>
				<Button className="undo-redo__button" size="small" type="text" disabled={disabled || !canRedo} onClick={onRedo}>Redo</Button>
			</Tooltip>
		</div>
	);
}
